import { ContextStylesParams, CSSObject } from '@mantine/core'

const baseInputStyle = {
    borderRadius: '0.4rem !important',
    appearance: 'none !important',
    ':checked:not(:disabled)': {
        backgroundColor: 'var(--mantine-bg-primary-filled) !important'
    },
    '::after': {
        display: 'none !important'
    }
}

const baseLabelStyle = {
    paddingLeft: '1.2rem',
    fontFamily: 'var(--fira-font-regular) !important',
    paddingBottom: 'none !important'
}

const SIZES = {
    xs: {
        '.mantine-Checkbox-inner': {
            height: '1.6rem !important',
            width: '1.6rem !important'
        },
        input: {
            ...baseInputStyle,
            height: '1.6rem !important',
            width: '1.6rem !important'
        },
        label: {
            ...baseLabelStyle,
            height: '1.6rem !important',
            lineHeight: '1.6rem',
            fontSize: '1.2rem !important'
        }
    },
    sm: {
        '.mantine-Checkbox-inner': {
            height: '2rem !important',
            width: '2rem !important'
        },
        input: {
            ...baseInputStyle,
            height: '2rem !important',
            width: '2rem !important'
        },
        label: {
            ...baseLabelStyle,
            height: '2rem !important',
            lineHeight: '2rem',
            fontSize: '1.4rem !important'
        }
    },
    md: {
        '.mantine-Checkbox-inner': {
            height: '2.4rem !important',
            width: '2.4rem !important'
        },
        input: {
            ...baseInputStyle,
            height: '2.4rem !important',
            width: '2.4rem !important'
        },
        label: {
            ...baseLabelStyle,
            height: '2.4rem !important',
            lineHeight: '2.4rem',
            fontSize: '1.6rem !important'
        }
    },
    lg: {
        '.mantine-Checkbox-inner': {
            height: '3rem !important',
            width: '3rem !important'
        },
        input: {
            ...baseInputStyle,
            height: '3rem !important',
            width: '3rem !important'
        },
        label: {
            ...baseLabelStyle,
            height: '3rem !important',
            lineHeight: '3rem',
            fontSize: '1.8rem !important'
        }
    },
    xl: {
        '.mantine-Checkbox-inner': {
            height: '3.6rem !important',
            width: '3.6rem !important'
        },
        input: {
            ...baseInputStyle,
            height: '3.6rem !important',
            width: '3.6rem !important'
        },
        label: {
            ...baseLabelStyle,
            height: '3.6rem !important',
            lineHeight: '3.6rem',
            fontSize: '2rem !important'
        }
    }
}

export const getCheckboxStyles = (props: ContextStylesParams): Record<string, CSSObject> => {
    const style = SIZES[props?.size] || {}

    return {
        root: {
            display: 'flex',
            ...style
        }
    }
}
